// extracted by mini-css-extract-plugin
module.exports = {"paymentColumn":"PaymentPage_paymentColumn__3fNZg","paymentContainer":"PaymentPage_paymentContainer__3D9LT"};